export const SCENARIO_SETTINGS_URL: string = 'ows/beta/ScenarioSettings';
